import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { FileText, ArrowRight, X } from "lucide-react";

export default function CorrectedDocReminderBanner() {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/me/corrected-doc-reminders").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (dismissed || items.length === 0) return null;

  return (
    <div className="rounded-3xl bg-amber-50 border border-amber-200 p-5 flex items-start gap-4" data-testid="corrected-doc-reminder-banner">
      <div className="h-10 w-10 rounded-2xl bg-amber-100 text-amber-600 flex items-center justify-center shrink-0 mt-0.5">
        <FileText className="h-5 w-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-bold text-amber-900">
          {items.length === 1
            ? `Tu as un document corrigé à consulter depuis ${items[0].days} jour${items[0].days > 1 ? "s" : ""}`
            : `Tu as ${items.length} documents corrigés à consulter`}
        </p>
        <ul className="mt-1.5 space-y-1">
          {items.map((it) => (
            <li key={`${it.kind}-${it.id}`}>
              <Link
                to={it.kind === "career" ? "/recherche-stage" : "/cours"}
                data-testid={`corrected-doc-reminder-item-${it.id}`}
                className="inline-flex items-center gap-1.5 text-sm font-bold text-amber-700 hover:text-amber-800 hover:underline"
              >
                {it.title} ({it.days} j) <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <button onClick={() => setDismissed(true)} data-testid="corrected-doc-reminder-dismiss" className="text-amber-400 hover:text-amber-600 shrink-0">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
